import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { tagsFeature } from './state/tags.feature';
import { TagsEffects } from './state/tags.effects';

export const TAGS_STORE_PROVIDERS = {
  feature: provideState(tagsFeature),
  effects: provideEffects(TagsEffects),
};
